import { jsx } from "react/jsx-runtime";
import { Skeleton } from "@nxt-costco-com/forge-components";
const AnnouncementBannerSkeleton = () => {
  return /* @__PURE__ */ jsx(Skeleton, { sx: { height: "31px", width: "100%" } });
};
export {
  AnnouncementBannerSkeleton
};
